import { render, staticRenderFns } from "./active-list.vue?vue&type=template&id=f09f8830&"
import script from "./active-list.vue?vue&type=script&lang=js&"
export * from "./active-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports